export const CHART_DATE_FORMAT = `MMM d, yyyy`;
export const CHART_DATE_FORMAT_MONTH_SHORT = `MMM`;
export const CHART_DATE_FORMAT_MONTH = 'MMMM';
export const CHART_DATE_FORMAT_DATE_SHORT  = `d`;
export const CHART_DATE_FORMAT_YEAR_SHORT  = `yyyy`;
export const DATE_FORMAT_CUSTOM_VALUE = `yyyy-MM-dd`;

export const MAX_MUTATIONS = 3;
export const MAX_LINEAGES = 3;
export const MAX_COUNTRIES = 20;

export const MIN_PCT = 0; //0.15;

export const MIN_CHARS_MUTATIONS_SEARCH = 1;
export const NUM_RESULTS_FOR_EACH_GENE_REGION = 20;
export const ADDL_RESULTS_FOR_EACH_GENE_REGION = 100;
export const MIN_CHARS_COUNTRIES_SEARCH = 2;

export const UNCERTAIN_THRESHOLD = 100;

export const PROVINCE_SEPARATOR = "--";
